export const CONSOLE_VERSION = 'sha-5312809';
